<form [formGroup]="form" (ngSubmit)="applyTempChanges()">
  <div class="mb-3 row">
    <div class="col-lg-4" [ngClass]="{'has-error':!name.valid}">
      <label>Filter Name</label>
      <input type="text" class="form-control" [formControl]="name" />
      @if (name.hasError('required')) {
        <div class="alert alert-danger">Filter Name is required</div>
      }
    </div>
    <div class="col-lg-3" [ngClass]="{'has-error':!baseIncludeScope.valid}">
      <label>Devices to Include</label>
      <select class="form-control" [formControl]="baseIncludeScope" (change)="updateFilterSummary()">
        <option value="AllDevices">All Devices</option>
        <option value="AllSnmpDevices">SNMP Devices Only</option>
        <option value="AllNetworkDevices">Network Devices Only</option>
      </select>
    </div>
  </div>
  <div class="mb-3 row">
    <div class="col-lg-12">
      <p-tabView>
        <p-tabPanel header="Hosts" [selected]="true">
          <div class="filter-tab" [ngClass]="{'has-error':!nameFilters.valid}">
            <label>Host / System / NetBIOS Names (* and ? are wildcards)</label>
            <div class="row" style="margin: 5px;">
              <textarea rows="6" class="col-lg-12" [formControl]="nameFilters" (input)="updateFilterSummary()"></textarea>
              @if (nameFilters.hasError('validNameFilters')) {
                <div class="alert alert-danger">Invalid host/system name filters</div>
              }
            </div>
          </div>
        </p-tabPanel>
        <p-tabPanel header="IP Ranges">
          <div class="filter-tab" [ngClass]="{'has-error':!ipScopeFilters.valid}">
            <label>IP Addresses / Ranges / Subnets</label>
            <div class="row" style="margin: 5px;">
              <textarea rows="6" class="col-lg-12" [formControl]="ipScopeFilters" (input)="updateFilterSummary()"></textarea>
              @if (ipScopeFilters.hasError('validIpScopeFilters')) {
                <div class="alert alert-danger">Invalid IP range filters</div>
              }
            </div>
          </div>
        </p-tabPanel>
        <p-tabPanel header="VLANs">
          <div class="filter-tab" [ngClass]="{'has-error':!vlanFilters.valid}">
            <label>VLAN Names / Indexes (* and ? are wildcards)</label>
            <div class="row" style="margin: 5px;">
              <textarea rows="6" class="col-lg-12" [formControl]="vlanFilters" (input)="updateFilterSummary()"></textarea>
              @if (vlanFilters.hasError('validVlanFilters')) {
                <div class="alert alert-danger">Invalid VLAN filters</div>
              }
            </div>
          </div>
        </p-tabPanel>
        <p-tabPanel header="OIDs">
          <div class="filter-tab" [ngClass]="{'has-error':!oidFilters.valid}">
            <label>SNMP OIDs/Object Identifiers (* and ? are wildcards)</label>
            <div class="row" style="margin: 5px;">
              <textarea rows="6" class="col-lg-12" [formControl]="oidFilters" (input)="updateFilterSummary()"></textarea>
              @if (oidFilters.hasError('validOidFilters')) {
                <div class="alert alert-danger">Invalid OID filters</div>
              }
            </div>
          </div>
        </p-tabPanel>
        <p-tabPanel header="Categories">
          <div class="filter-tab">
            <label>Device Categories (all checked/unchecked = no filter)</label>
            <div class="row">
              <div class="col-lg-12">
                <device-category-selector [(selection)]="deviceCategories" scrollHeight="135px"
                  (selectionChange)="onCategoriesChange()">
                </device-category-selector>
              </div>
            </div>
          </div>
        </p-tabPanel>
      </p-tabView>
    </div>
  </div>
  <div class="mb-3 row">
    <div class="col-lg-12">
      <label>Filter Summary</label>
      <textarea style="display: block; border-radius: 4px; width: 550px;" rows="8" readonly>{{filterSummary}}</textarea>
    </div>
  </div>
  <button type="submit" pButton style="margin-top: 10px;" [disabled]="!form.valid || form.pristine"
  label="Apply"></button>
  <button type="button" pButton style="margin-top: 10px;" (click)="onPreview()" [disabled]="!form.valid"
  label="Preview"></button>

  <device-preview header="Matching Devices" [(visible)]="previewVisible" [devices]="previewDevices"
  (visibleChange)="onPreviewVisibleChange($event)"></device-preview>
</form>
